import { lazyLoad } from 'utils/loadable';

export const HearFromCommunityPage = lazyLoad(
  () => import('./HearFromCommunityPage'),
  module => module.HearFromCommunityPage,
);
